import type { MouseEvent } from 'react';
import type { Page } from '../../../types';

/** Ctrl/cmd/clique com modificador: deixa o navegador seguir o href (nova aba, etc.). */
export function isModifiedClick(e: MouseEvent): boolean {
    return e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;
}

export function handleSidebarNavClick(
    e: MouseEvent<HTMLAnchorElement>,
    setCurrentPage: (page: Page) => void,
    page: Page
): void {
    if (!isModifiedClick(e)) {
        e.preventDefault();
        setCurrentPage(page);
    }
}
